import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
// External dependencies
import { useContext, useState, } from 'react';
import { IconButton, Box, Dialog, DialogTitle, DialogContent, DialogActions, Autocomplete, Typography, } from '@mui/material';
import { TranslateOutlined } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
// Internal dependencies
import { ButtonSG, TextFieldSG } from '../../components';
import { OUTPUT_LANGUAGES, MULTILANGUAGE } from '../../constants';
import { UserContext } from '../../auth';
import { appStyles } from '../../App.styles';
import { languageSGStyles } from './languageSG.styles';
const /** Display languages */ lngs = Object.values(MULTILANGUAGE);
/**
 * Language Button
 * @param {ButtonProps} props
 * @returns {JSX.Element}
 */
export const LanguageSG = function (props) {
    // Extract translation function
    const { t, i18n } = useTranslation();
    // Load user credential
    const user = useContext(UserContext);
    // List of Output languages
    const outputLanguages = Object.values(OUTPUT_LANGUAGES);
    // Output language
    const { outputLanguage, setOutputLanguage } = props;
    // Is Output language open
    const [outputLanguageOpen, setOutputLanguageOpen] = useState(false);
    /**
     * Handle Output Language Click
     */
    const handleOutputLanguageClick = () => {
        setOutputLanguageOpen(true);
        return true;
    };
    /**
     * Handle Output Language Close
     */
    const handleOutputLanguageClose = () => {
        setOutputLanguageOpen(false);
        return true;
    };
    /**
     * Handle Language Item Click
     * @param {string} code
     */
    const handleLanguageItemClick = (code) => {
        i18n.changeLanguage(code);
        return true;
    };
    return (_jsxs(Box, { children: [_jsx(IconButton
            // Mobile Output language button
            , Object.assign({ "aria-label": "Output Language button", onClick: handleOutputLanguageClick }, { children: _jsx(TranslateOutlined, { sx: { color: 'blackDark.main' } }) })), _jsxs(Dialog
            // Output language dialog
            , Object.assign({ 
                // Output language dialog
                sx: {
                    '& .MuiDialog-paper': {
                        backgroundColor: 'white.main',
                        borderRadius: '1rem',
                    }
                }, open: outputLanguageOpen, onClose: handleOutputLanguageClose }, { children: [_jsx(DialogTitle, Object.assign({ sx: Object.assign(Object.assign({}, appStyles.text22), { padding: '1.5rem', fontWeight: 'regular', display: 'flex', color: 'greyBlack' }) }, { children: t('Language Setting') })), _jsxs(DialogContent, Object.assign({ sx: { padding: '0 1.5rem 0.5rem' } }, { children: [_jsx(Autocomplete, { sx: Object.assign(Object.assign({}, languageSGStyles.autocomplete), { '& .MuiBox-root': { padding: '0 0 0.25rem' } }), value: { label: MULTILANGUAGE[i18n.language].name, value: i18n.language }, onChange: (event, newValue) => {
                                    handleLanguageItemClick(newValue.value);
                                }, isOptionEqualToValue: (option, value) => (option.value === value.value), options: lngs.map((displayLanguage) => ({ label: displayLanguage.name, value: displayLanguage.value })), disableClearable: true, renderInput: (params) => _jsx(TextFieldSG, Object.assign({}, params, { label: "Display Language" })) }), _jsx(Typography, Object.assign({ variant: 'text12', sx: { padding: '0 0 0 1rem' } }, { children: t('This controls the app interface language') })), _jsx(Autocomplete, { sx: Object.assign(Object.assign({}, languageSGStyles.autocomplete), { margin: '2rem 0 0', '& .MuiBox-root': { padding: '0 0 0.25rem' } }), value: { label: t(outputLanguage), value: outputLanguage }, onChange: (event, newValue) => {
                                    setOutputLanguage(newValue.value);
                                }, isOptionEqualToValue: (option, value) => (option.value === value.value), options: outputLanguages.map((outputLanguage) => ({ label: t(outputLanguage), value: outputLanguage })), disableClearable: true, renderInput: (params) => _jsx(TextFieldSG, Object.assign({}, params, { label: "Output Language" })) }), _jsx(Typography, Object.assign({ variant: 'text12', sx: { padding: '0 0 0 1rem' } }, { children: t('This controls the AI generation language') }))] })), _jsx(DialogActions, Object.assign({ sx: { justifyContent: 'center', padding: '1.5rem' } }, { children: _jsx(ButtonSG, Object.assign({ variant: "contained", onClick: handleOutputLanguageClose }, { children: t('Save') })) }))] }))] }));
};
